export enum ShippingMethod {
  Delivery = 'delivery',
  Pickup = 'pickup'
}
